/**
 * Lecturer Guard
 *
 * Route guard to protect lecturer-only routes
 * Checks if the user has the 'lecturer' role
 */

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserRoleService } from './user-role.service';

export const lecturerGuard: CanActivateFn = () => {
  const roleService = inject(UserRoleService);
  const router = inject(Router);

  // Check if user is a lecturer
  if (roleService.isLecturer()) {
    return true;
  }

  // If not a lecturer, redirect to dashboard
  console.warn('⚠️ Access denied: User is not a lecturer');
  router.navigate(['/app/dashboard']);
  return false;
};
